
import { BreakoutScene } from './breakout/BreakoutScene';
import { scenes as helicopterScenes } from './helicopters/scenes/scenes';
import MortarsScene from './mortars';


export const gameScenes = {
    Breakout: { sceneMap: { Breakout: BreakoutScene }, root: 'Breakout' },
    Helicopters: { sceneMap: helicopterScenes, root: 'Splash' },
    Mortars: { sceneMap: { Mortars: MortarsScene }, root: 'Mortars' },
    Skyline: { path: '/games/skyline/skyline.html' }
} as const;
